exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1qpRVdIBXU9wVM{display:block;color:#5e6c84;margin-bottom:4px}._32eZ6unCylWxXR{position:relative;background:#f4f5f7;border-radius:3px;box-shadow:0 0 0 1px rgba(9,30,66,.13);padding-right:36px}._2gUCoa1xQPsLXx{white-space:nowrap;flex:1;margin:0;background:transparent;border:0;box-shadow:none}._3QHW-h3gupEwe5{position:absolute;right:0;top:0;margin:0;padding:1px;transition:.3s ease-in-out;background:#f4f5f7;border:1px solid transparent}._3QHW-h3gupEwe5:focus,._3QHW-h3gupEwe5:hover{background-color:#c1c7d0}._37nrJQ8Iu4Ovyq,._37nrJQ8Iu4Ovyq:focus,._37nrJQ8Iu4Ovyq:hover{background:#519839}._3he9MT_MyqmhNl,._3he9MT_MyqmhNl:focus,._3he9MT_MyqmhNl:hover{background:#b04632}", ""]);

// exports
exports.locals = {
	"headURLTitle": "_1qpRVdIBXU9wVM",
	"headURLContainer": "_32eZ6unCylWxXR",
	"headURL": "_2gUCoa1xQPsLXx",
	"copy": "_3QHW-h3gupEwe5",
	"copySuccess": "_37nrJQ8Iu4Ovyq",
	"copyError": "_3he9MT_MyqmhNl"
};